{
  "common": {
    "appName": "FLOWTIFY",
    "save": "Save",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "continue": "Continue",
    "back": "Back",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "loading": "Loading...",
    "search": "Search",
    "select": "Select",
    "edit": "Edit",
    "delete": "Delete",
    "create": "Create",
    "language": "Language"
  },
  "toasts": {
    "loadSellersError": "Error loading sellers, please try again.",
    "invalidCredentials": "Invalid username or password, please try again.",
    "selectSeller": "Select a Seller",
    "loginError": "Error signing in, please try again.",
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "accessDenied": "Access Denied"
  },
  "nav": {
    "dashboard": "Dashboard",
    "labels": "Labels",
    "orders": "Orders",
    "qrScanner": "QR Scanner",
    "invoices": "Invoices",
    "production": "Production",
    "productGroup": "Product Group",
    "users": "Users",
    "settings": "Settings",
    "integrations": "Integrations",
    "mlStub": "ML stub",
    "logout": "Sign out",
    "tip": {
      "dashboard": "Dashboard: View strategic charts and cards",
      "labels": "Labels: Print and manage your sales labels",
      "orders": "Orders: View the seller's orders by date range",
      "qrScanner": "QR Code Scanner: Use your phone as a scanner",
      "invoicesRegularize": "Invoices: Settle your invoice",
      "invoices": "Invoices: View and manage your invoices",
      "production": "Production: Track your production",
      "productGroup": "Production: Track and create your production order",
      "users": "Internal Users: Manage the system's internal users",
      "settings": "Settings: Configure system parameters",
      "integrations": "Integrations: Manage the marketplaces connected to your account",
      "mlStub": "Mercado Livre stub: simulate orders, shipments and failures (development only)",
      "logout": "Sign out of the application"
    }
  },
  "header": {
    "seller": "Seller:",
    "selectAccount": "Select an account",
    "blockedAccess": "Access blocked",
    "blockedMessage": "You have invoice(s) overdue for more than 7 days. Settle it to keep accessing the system.",
    "invoiceOverdueOne": "Overdue Invoice",
    "invoiceOverdueMany": "Overdue Invoices",
    "riskInterruption": "Risk of service interruption",
    "invoiceDueTodayOne": "Invoice Due Today",
    "invoiceDueTodayMany": "Invoices Due Today",
    "dueTodayWarning": "Attention: due today",
    "invoiceUpcomingOne": "Invoice Due Soon",
    "invoiceUpcomingMany": "Invoices Due Soon",
    "upcomingInfo": "Invoices due in the coming days"
  },
  "dialog": {
    "switchAccountTitle": "Switch Account",
    "switchAccountMessage": "You are about to switch accounts.\n\nThis will sign out the current account.\n\nDo you want to continue?"
  },
  "login": {
    "welcome": "Welcome",
    "subtitle": "Sign in to continue",
    "tabMl": "Mercado Libre",
    "tabPassword": "Username & Password",
    "mlDescription": "Sign in with your Mercado Libre account quickly and securely",
    "mlButton": "Sign in with Mercado Libre",
    "tabShopee": "Shopee",
    "shopeeDescription": "Sign in with your Shopee account quickly and securely",
    "shopeeButton": "Sign in with Shopee",
    "username": "Username",
    "usernamePlaceholder": "Enter your username",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "selectSeller": "Select Seller",
    "enter": "Sign in",
    "forgotPassword": "Forgot my password"
  },
  "users": {
    "tabUsers": "Users",
    "tabProfiles": "Profiles",
    "usersTitle": "Internal Users",
    "profilesTitle": "Profiles",
    "newUser": "New User",
    "newProfile": "New Profile",
    "emptyUsers": "No users found.",
    "emptyProfiles": "No profiles found.",
    "edit": "Edit",
    "delete": "Delete",
    "validated": "Validated",
    "notValidated": "Not Validated",
    "active": "Active",
    "inactive": "Inactive",
    "confirmDeleteTitle": "Confirm Deletion",
    "confirmDeleteUser": "Are you sure you want to delete the user {{email}}?\n\nThis is a soft delete and the user will no longer appear in the list.",
    "confirmDeleteProfile": "Are you sure you want to delete the profile {{name}}?\n\nThis is a soft delete and the profile will no longer appear in the list.",
    "col": {
      "email": "Email",
      "emailValidated": "Email Validated",
      "profiles": "Profiles",
      "createdAt": "Created on",
      "actions": "Actions",
      "name": "Name",
      "description": "Description",
      "status": "Status"
    },
    "toast": {
      "loadUsersError": "Error loading users.",
      "noCreatePermission": "You do not have permission to create users.",
      "noEditPermission": "You do not have permission to edit users.",
      "noDeletePermission": "You do not have permission to delete users.",
      "userDeleted": "User deleted successfully",
      "userDeleteError": "Error deleting user.",
      "loadProfilesError": "Error loading profiles.",
      "profileDeleted": "Profile deleted successfully",
      "profileNotFound": "Profile not found.",
      "profileDataError": "Invalid data. Error processing the profile.",
      "profileGenericError": "An error occurred while processing the profile, please try again.",
      "loadProfilesListError": "Error loading the profiles list.",
      "loadUserError": "Error loading the user.",
      "userCreated": "User created successfully!",
      "userUpdated": "User updated successfully!",
      "userNotFound": "User not found.",
      "emailInUse": "This email is already in use.",
      "userDataError": "Invalid data. Error processing the user.",
      "userGenericError": "An error occurred while processing the user, please try again.",
      "loadPermissionsError": "Error loading the permissions tree.",
      "loadProfileError": "Error loading the profile.",
      "profileCreated": "Profile created successfully!",
      "profileUpdated": "Profile updated successfully!"
    },
    "form": {
      "editUser": "Edit User",
      "createUser": "Create User",
      "emailPlaceholder": "user@example.com",
      "emailRequired": "Email is required.",
      "emailInvalid": "Invalid email.",
      "password": "Password",
      "passwordPlaceholder": "Minimum 6 characters",
      "passwordRequired": "Password is required.",
      "passwordMin": "The password must be at least 6 characters.",
      "confirmPassword": "Confirm Password",
      "confirmPasswordPlaceholder": "Confirm the password",
      "confirmRequired": "Password confirmation is required.",
      "passwordsMismatch": "The passwords do not match.",
      "selectProfiles": "Select profiles",
      "profilesHint": "Select one or more profiles to link to the user",
      "editProfile": "Edit Profile",
      "createProfile": "Create Profile",
      "name": "Name",
      "namePlaceholder": "Profile name",
      "nameRequired": "Name is required.",
      "nameMin": "The name must be at least 3 characters.",
      "description": "Description",
      "descriptionPlaceholder": "Profile description (optional)",
      "permissions": "Permissions",
      "loadingPermissions": "Loading permissions...",
      "selectAtLeastOnePermission": "You must select at least one permission.",
      "profileActive": "Active Profile"
    }
  },
  "integrations": {
    "title": "Integrations",
    "subtitle": "Manage the integrations connected to your account.",
    "loading": "Loading integrations...",
    "loadError": "Unable to load integrations.",
    "active": "Active",
    "inactive": "Inactive",
    "cannotDisable": "Required integration — it cannot be disabled."
  },
  "breadcrumb": {
    "home": "Home",
    "labelPrint": "Label Printing",
    "checklist": "Check",
    "noPermission": "No permission",
    "page": "Page"
  },
  "health": {
    "summary": {
      "healthy": "Services operating",
      "degraded": "Services unstable",
      "unhealthy": "Services down",
      "unknown": "Checking services"
    },
    "message": {
      "healthy": "All services are operating normally.",
      "issue": "One or more services are experiencing instability.",
      "unknown": "Checking services status."
    },
    "status": {
      "healthy": "Operating",
      "degraded": "Unstable",
      "unhealthy": "Down",
      "unknown": "Not checked"
    },
    "tooltipOk": "All services operating.",
    "tooltipIssue": "Services experiencing instability.",
    "services": {
      "database": "Database",
      "messaging": "Messaging",
      "mercadoLivre": "Mercado Livre",
      "availability": "Availability",
      "authentication": "Authentication"
    },
    "lastCheck": "Last check:",
    "waiting": "Waiting..."
  },
  "settings": {
    "title": "Settings",
    "theme": "Theme",
    "themeHint": "Choose light, dark, or follow the system",
    "configurePrinters": "Configure printers",
    "readOnly": "You are viewing this screen in read-only mode. You do not have permission to edit settings.",
    "printerName": "Printer Name",
    "printerNamePlaceholder": "Enter the printer name",
    "printFormat": "Print Format",
    "printTest": "Print test",
    "loadingPrinters": "Loading printers...",
    "online": "Online",
    "offline": "Offline",
    "noPrinters": "No printers found.",
    "loadPrintersError": "Could not load the list of printers.",
    "toast": {
      "noEditPermission": "You do not have permission to edit settings.",
      "saved": "Settings saved successfully!",
      "saveError": "An error occurred while saving the settings, please try again!",
      "enterPrinterName": "Please enter the printer name.",
      "selectPrinterToTest": "Select a printer to test.",
      "testSent": "Test print sent.",
      "testFailed": "Failed to send the test print.",
      "testError": "Error printing test."
    }
  },
  "labels": {
    "title": "LABEL PRINTING",
    "todayCount": "Labels printed today: {{count}}",
    "orderIdPlaceholder": "Scan the QR code or enter the sale number",
    "stopCamera": "Stop Camera",
    "useCamera": "Use Camera",
    "cameraDenied": "Camera permission denied. Please allow camera access in your browser settings.",
    "mobileScanner": "Mobile Scanner",
    "waitingMobile": "Waiting for mobile...",
    "viewQrCode": "View QR Code",
    "deactivate": "Deactivate",
    "activate": "Activate",
    "connectMobile": "Connect Mobile",
    "scanToConnect": "Scan this QR Code with your phone to connect:",
    "sessionQrAlt": "Session QR Code",
    "howToUse": "How to use:",
    "step1a": "Sign in at",
    "step1b": "on your phone",
    "step2a": "Go to the menu",
    "step2b": "QR Code Scanner",
    "step3a": "Click",
    "step3b": "Scan Session QR Code",
    "step4": "Scan the QR Code above",
    "waitingConnect": "Waiting for mobile to connect...",
    "fetchingData": "Fetching label data from Mercado Libre.....",
    "sendingPrint": "Sending label to printer.....",
    "sentToPrinter": "Labels sent to printer",
    "saleNumber": "Sale Number",
    "action": "Action",
    "dateTime": "Date/Time",
    "observation": "Note",
    "clickToIssue": "Click to issue",
    "reprint": "Reprint",
    "reprintHint": "Send this label to the printer again",
    "revokeDevice": "Disconnect",
    "stationCode": "Station code",
    "pairingCodeExpiresIn": "Expires in {{seconds}}s",
    "pairingCodeExpired": "Code expired. Generate a new one.",
    "newPairingCode": "New pairing code",
    "pairStep1": "Point your phone camera at the QR code above",
    "pairStep2": "Tap the link that appears on the screen",
    "pairStep3": "Type below the 6-digit number shown on the phone",
    "pairStep4": "Done — you can start scanning",
    "pairNoLogin": "No login required on the phone.",
    "typeConfirmationCode": "Code shown on the phone",
    "confirmationPlaceholder": "000000",
    "confirmPairing": "Confirm",
    "confirmationHint": "Only the device that scanned the QR code shows this number.",
    "deviceWaiting": "{{device}} is waiting for confirmation.",
    "loadingMoreLogs": "Loading more logs...",
    "viewOnMl": "View on Mercado Libre",
    "toast": {
      "titleScanner": "Mobile Scanner",
      "titleError": "Error",
      "titleSuccess": "Success",
      "titleAccessDenied": "Access Denied",
      "mobileConnected": "Mobile connected: {{name}}",
      "mobileDisconnected": "Mobile disconnected",
      "sessionDisconnected": "Session disconnected",
      "qrReceived": "QR Code received from mobile: {{data}}",
      "noPrintPermission": "You do not have permission to print labels.",
      "labelSent": "Label sent to printer",
      "printError": "An error occurred while printing the label, please check that the printer is connected.",
      "printErrorAction": "Label printing error",
      "labelFetchError": "Could not get the label from Mercado Libre, please try again, or print manually from the Mercado Libre panel.",
      "labelFetchErrorAction": "Error getting label",
      "invoiceNotIssued": "Invoice not issued",
      "invoiceIssuedWaiting": "Invoice issued. Waiting to send the label to the printer.",
      "invoiceIssueError": "Could not issue the invoice, please try via the Mercado Libre portal.",
      "qrDetected": "QR Code detected: {{id}}",
      "scannerModeOn": "Mobile scanner mode activated",
      "scannerModeOnError": "Error activating mobile scanner mode",
      "scannerModeOff": "Mobile scanner mode deactivated",
      "scannerModeOffError": "Error deactivating mobile scanner mode",
      "pairingCodeError": "Could not generate a new pairing code.",
      "deviceRevoked": "Phone disconnected from the station.",
      "pairingConfirmed": "Phone paired successfully.",
      "pairingConfirmError": "Could not confirm the pairing.",
      "qrGenError": "Error generating QR Code"
    }
  },
  "orders": {
    "startDate": "Start Date",
    "endDate": "End Date",
    "shippingStatus": "Shipping Status",
    "clear": "Clear",
    "search": "Search",
    "totalOrders": "Total Orders:",
    "printerOffline": "Printer offline",
    "print": "Print",
    "loadingWait": "Loading, please wait...",
    "selectAll": "Select all",
    "units": "unit(s)",
    "printingLabels": "Printing {{count}} label(s), please wait...",
    "status": {
      "all": "All",
      "pending": "Pending",
      "readyToShip": "Ready to Ship",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "notDelivered": "Not Delivered",
      "cancelled": "Cancelled",
      "inTransit": "In Transit"
    },
    "col": {
      "id": "Identifier",
      "product": "Product",
      "attributes": "Attributes",
      "sku": "SKU",
      "status": "Status",
      "manufacturingEnd": "Manufacturing Completion Date",
      "price": "Price",
      "quantity": "Quantity"
    }
  },
  "sellerOrders": {
    "title": "Orders",
    "subtitle": "View the seller's orders by date range",
    "startDate": "Start Date",
    "endDate": "End Date",
    "search": "Search",
    "rangeHint": "Maximum range of 7 days.",
    "total": "Total orders:",
    "loading": "Loading, please wait...",
    "empty": "No orders found for the selected period.",
    "page": "Page {{current}} of {{total}}",
    "previous": "Previous",
    "next": "Next",
    "col": {
      "orderId": "Order",
      "date": "Date",
      "buyer": "Buyer",
      "product": "Product",
      "items": "Items",
      "quantity": "Qty.",
      "status": "Status",
      "total": "Total"
    },
    "errors": {
      "required": "Please enter the start and end dates.",
      "endBeforeStart": "The end date cannot be earlier than the start date.",
      "rangeTooLarge": "The maximum allowed range is {{max}} days.",
      "loadError": "Error loading orders."
    }
  },
  "invoices": {
    "title": "INVOICES",
    "totalCount": "Total: {{count}} invoices",
    "empty": "No invoices found.",
    "invoiceLabel": "Invoice",
    "totalAmount": "Total Amount",
    "due": "Due:",
    "overdue": "OVERDUE",
    "itemsCount": "{{count}} item(s)",
    "payNow": "Pay now",
    "clickForDetails": "Click to view details",
    "loadingMore": "Loading more invoices...",
    "status": {
      "pending": "Pending",
      "issued": "Issued",
      "paid": "Paid",
      "cancelled": "Cancelled",
      "unknown": "Unknown"
    },
    "detail": {
      "overdueTitle": "OVERDUE INVOICE",
      "overdueText": "This invoice is overdue and requires immediate attention.",
      "details": "Invoice Details",
      "number": "Number:",
      "qrTitle": "QR Code for Payment",
      "paymentConfirmed": "Payment Confirmed!",
      "paymentConfirmedSuccess": "Payment confirmed successfully!",
      "moreDetails": "+details",
      "createdDate": "Created Date",
      "dueDate": "Due Date",
      "lastUpdate": "Last Update",
      "invoiceItems": "Invoice Items",
      "colDescription": "Description",
      "colValue": "Value",
      "totalLabel": "Total:",
      "noItems": "No items found in this invoice.",
      "backToDetails": "Back to Details"
    },
    "payment": {
      "title": "Payment Details",
      "email": "Email",
      "firstName": "First Name",
      "lastName": "Last Name"
    },
    "errors": {
      "emailRequired": "Email is required",
      "emailInvalid": "Invalid email",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required"
    },
    "toast": {
      "noViewPermission": "You do not have permission to view invoices.",
      "noPayPermission": "You do not have permission to pay invoices.",
      "qrError": "Error generating QR Code. Please try again."
    }
  },
  "qrScanner": {
    "title": "QR CODE SCANNER",
    "connectToSession": "Connect to Station",
    "pairing": "Connecting to the station...",
    "station": "Station",
    "typeOnDesktop": "Type this number on the computer to allow this phone:",
    "waitingConfirmation": "Waiting for confirmation... {{seconds}}s",
    "codeOnlyHere": "This number appears only on this device.",
    "stationOffline": "The station computer is disconnected.",
    "stationOfflineHint": "You are still paired. As soon as it is back, just keep scanning.",
    "initializingCamera": "Initializing camera...",
    "cameraDenied": "Camera permission denied. Please allow camera access in your browser settings.",
    "scanSessionInstruction": "Scan the QR Code shown on the computer screen to connect your phone to the scanner session.",
    "scanning": "Scanning...",
    "scanQrCode": "Scan QR Code",
    "sendingQrCode": "Sending QR Code...",
    "stopScanner": "Stop Scanner",
    "startScanner": "Start Scanner",
    "sessionConnected": "Session connected",
    "disconnect": "Disconnect",
    "sendHistory": "Send History",
    "noSendsYet": "No QR Code sent yet",
    "sent": "Sent",
    "errorShort": "Error",
    "toast": {
      "titleScanner": "Scanner",
      "titleError": "Error",
      "qrSent": "QR Code sent successfully",
      "qrSendError": "Error sending QR Code",
      "sessionDisconnectedByServer": "Session disconnected by the server",
      "initScannerError": "Error initializing scanner. Reload the page and try again.",
      "cameraDenied": "Camera permission denied. Please allow camera access in your browser settings.",
      "cameraDeniedShort": "Camera permission denied. Please allow camera access.",
      "cameraNotFound": "Camera not found. Check that the device has a camera and that it is available.",
      "scannerStartError": "Error starting scanner: {{error}}",
      "connected": "Connected to station {{code}}",
      "connectError": "Error connecting to the station. Scan the QR code on the computer screen again.",
      "pairError": "Could not pair with the station. Scan the QR code again.",
      "sessionGone": "The station ended the session. Scan the QR code again to reconnect.",
      "invalidStationQr": "This QR code does not belong to a Flowtify station.",
      "stationOffline": "The station computer went offline. Wait for it to come back.",
      "stationBack": "Station is back. You can keep scanning.",
      "qrSentData": "QR Code sent: {{data}}"
    }
  },
  "checklist": {
    "tabInitial": "Initial",
    "tabCreateEdit": "Create/Edit",
    "tabScan": "Scan",
    "title": "PRODUCTION ORDER SEARCH",
    "startDate": "Start Date",
    "endDate": "End Date",
    "search": "Search",
    "createOrder": "Create Order",
    "pendingOrdersSuffix": "PENDING ORDERS",
    "colSaleNumber": "Sale Number",
    "colDescription": "Description",
    "colQtItems": "Qty Items",
    "colSku": "SKU",
    "colStatus": "Status",
    "colCreatedDate": "Created Date",
    "colEndDate": "End Date",
    "createOrEdit": "Create or Edit",
    "createEditContent": "This is the content of the Create/Edit tab.",
    "toast": {
      "searchError": "An error occurred while fetching the orders, please try again.",
      "orderCreated": "Production order created successfully. Go to the Production Orders screen to view the details.",
      "orderCreateError": "An error occurred while creating the production order, please try again.",
      "selectAtLeastOne": "Select at least 1 order to create the production order."
    }
  },
  "productGroup": {
    "filterTitle": "Filter Production Groups",
    "namePlaceholder": "Group Name",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "search": "Search",
    "createNew": "Create New",
    "colName": "Name",
    "colProducts": "Products",
    "colActive": "Active",
    "colDate": "Date",
    "colActions": "Actions",
    "edit": "Edit",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "createTitle": "Create Product Group",
    "groupName": "Group Name",
    "groupNamePlaceholder": "Enter the group name",
    "nameRequired": "The group name is required.",
    "selectProduct": "Select a Product",
    "filterProductsPlaceholder": "Type to filter products",
    "addProduct": "Add Product",
    "selectedProducts": "Selected Products",
    "colProduct": "Product",
    "remove": "Remove",
    "atLeastOneProduct": "The group must have at least one product.",
    "toast": {
      "activated": "Product group activated successfully",
      "deactivated": "Product group deactivated successfully",
      "toggleError": "An error occurred while changing the product group status.",
      "loadError": "Error loading the product group.",
      "created": "Group added successfully!",
      "createError": "An error occurred while creating the product group, please try again.",
      "updated": "Group updated successfully!",
      "updateError": "An error occurred while updating the product group."
    }
  },
  "charts": {
    "updatedAt": "Updated on",
    "period": "Period",
    "last7": "Last 7 days",
    "last15": "Last 15 days",
    "last30": "Last 30 days",
    "allTime": "All time",
    "top": "Top",
    "visualization": "View",
    "quantitySold": "Quantity sold",
    "quantityCancelled": "Quantity cancelled",
    "topSelling": "Best-selling products",
    "topSellingTreemap": "Best-selling products (Treemap)",
    "topSellingDonut": "Best-selling products (Donut)",
    "topCancelled": "Most cancelled products",
    "topCancelledTreemap": "Most cancelled products (Treemap)",
    "topCancelledDonut": "Most cancelled products (Donut)",
    "thisWeek": "This Week",
    "lastWeek": "Last Week",
    "salesComparison": "Sales Comparison",
    "startDate": "Start Date",
    "tooltipDate": "Date:",
    "days": { "mon": "Mon", "tue": "Tue", "wed": "Wed", "thu": "Thu", "fri": "Fri", "sat": "Sat", "sun": "Sun" }
  },
  "forgotPassword": {
    "title": "Forgot my password",
    "subtitle": "Enter your email to receive a reset link",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "sendLink": "Send reset link",
    "sending": "Sending...",
    "backToLogin": "Back to login",
    "successText": "If the email exists in our system, you will receive a link to reset your password shortly.",
    "toast": {
      "emailRequired": "Email is required",
      "emailInvalid": "Invalid email. Please check the email entered.",
      "connectionError": "Connection error. Please check your internet and try again.",
      "sendError": "Error sending email. Please try again."
    }
  },
  "resetPassword": {
    "title": "Reset password",
    "subtitle": "Enter your new password",
    "validatingLink": "Validating link...",
    "newPassword": "New Password",
    "newPasswordPlaceholder": "Enter your new password (minimum 6 characters)",
    "confirmPassword": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm your new password",
    "submit": "Reset Password",
    "submitting": "Resetting...",
    "successText": "Password reset successfully! You can now sign in with your new password.",
    "requestNewLink": "Request a new link",
    "toast": {
      "linkInvalid": "Invalid link. Please check the link or request a new one.",
      "linkExpired": "This link is no longer valid. Please request a new reset link.",
      "validateError": "Error validating the link. Please try again or request a new link.",
      "connectionError": "Connection error. Please check your internet and try again.",
      "passwordRequired": "Password is required",
      "passwordMin": "The password must be at least 6 characters",
      "passwordMax": "The password must be at most 100 characters",
      "confirmRequired": "Password confirmation is required",
      "passwordsMismatch": "The passwords do not match. Please check and try again.",
      "resetError": "Error resetting password. Please check the data and try again.",
      "resetErrorRetry": "Error resetting password. Please try again."
    }
  },
  "noPermission": {
    "title": "Restricted Access",
    "message": "You do not have the permissions required to access this application.",
    "contactAdmin": "Please contact the system administrator to request the appropriate permissions.",
    "logoutAndLogin": "Sign out and sign in again"
  },
  "landing": {
    "header": {
      "viewPlans": "View Plans",
      "access": "Access System"
    },
    "hero": {
      "subtitle": "Print labels with a beep and speed up your operation",
      "description": "Scan the QR code and print the label instantly. No file downloads, copying text, or complicated steps. Simple, fast and direct."
    },
    "features": {
      "title": "Key Features",
      "subtitle": "Everything you need to manage your sales efficiently",
      "dashboardTitle": "Smart Dashboard",
      "dashboardDesc": "View strategic charts and metrics in real time. Track best-selling products, cancellations and sales performance.",
      "bipTitle": "Print by Scanning a QR Code",
      "bipHighlight": "Core feature:",
      "bipDesc": "Scan the QR code and print the label instantly. No file downloads, copying text, or complicated steps. Simple, fast and straight to the point.",
      "scannerTitle": "QR Code Scanner",
      "scannerDesc": "Use your mobile device as a scanner. Scan QR codes quickly to speed up processes.",
      "invoicesTitle": "Billing Invoices",
      "invoicesDesc": "Track your Flowtify billing invoices. View amounts, due dates and stay in control of your service subscription.",
      "mlTitle": "Mercado Libre Integration",
      "mlDesc": "Connect easily with your Mercado Libre account. Fast and secure login with OAuth."
    },
    "roadmap": {
      "title": "Roadmap Q1 2026",
      "subtitle": "Features coming soon",
      "stockTitle": "Inventory Control",
      "stockDesc": "Manage your inventory intelligently with full control of inbound, outbound and movements.",
      "productionTitle": "Production",
      "productionDesc": "Track and manage your production with production orders, checklist and quality control.",
      "priceTitle": "Price Calculator",
      "priceDesc": "Calculate selling prices accurately considering costs, margins and Mercado Libre fees."
    },
    "plans": {
      "title": "Choose the Ideal Plan",
      "subtitle": "Flexible plans to fit your business",
      "popular": "Popular",
      "premium": "Premium",
      "perMonth": ".99 per month",
      "subscribe": "Subscribe",
      "labelPrinting": "Label printing",
      "perMonthCount": "{{count}} per month",
      "unlimited": "Unlimited",
      "dashboard": "Dashboard",
      "cancelledMetrics": "Cancelled sales metrics",
      "topSales": "Top sales",
      "weeklyComparison": "Weekly sales comparison",
      "production": "Production",
      "mlChat": "ML integrated chat",
      "aiIntegrated": "AI integrated",
      "stockControl": "Inventory Control",
      "priceCalculator": "Price calculator"
    },
    "benefits": {
      "title": "Why choose FLOWTIFY?",
      "timeTitle": "Time Saving",
      "timeDesc": "Automate repetitive tasks and focus on what truly matters for your business.",
      "securityTitle": "Security",
      "securityDesc": "Your data protected with security best practices and a secure Mercado Libre integration.",
      "multiplatformTitle": "Multiplatform",
      "multiplatformDesc": "Access from any device. Works perfectly on desktop, tablet and mobile.",
      "insightsTitle": "Smart Insights",
      "insightsDesc": "Make data-driven decisions. Detailed charts and reports for strategic analysis."
    },
    "cta": {
      "title": "Ready to optimize your sales?",
      "description": "Start using FLOWTIFY today and transform the way you manage your sales on Mercado Libre.",
      "access": "Access System"
    }
  }
}
